(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["activity_h5-app"] = factory(require("jQuery"));
	else
		root["activity_h5-app"] = factory(root["jQuery"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__378__) {
return 